export default defineNuxtPlugin(() => {
    if (process.env.NODE_ENV === 'production') {
      ['log', 'debug'].forEach((method) => {
        console[method] = () => {};
      });
    }
});